import { Availability } from '../../lib/types/models/availability/availability'
import { AvailabilityInput } from '../../lib/types/models/availability/availability-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateStaffAvailability(
  input: AvailabilityInput & { id: number; availabilityId: number }
) {
  const { id, availabilityId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.staffs.updateAvailability.url, { id, availabilityId }))
    .patch<Availability, AvailabilityInput>(data)
}
